import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    OnDestroy,
    OnInit
} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef
} from '@angular/material/dialog';
import { LgvModel } from '../../../../data-models/longevity.model';
import {
    BehaviorSubject,
    filter,
    first,
    Observable,
    pipe,
    take,
    tap
} from 'rxjs';
import { LgvLoanApplicationService } from '../../../../core/services/lgv-loan-application.service';
import {
    FormControl,
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators
} from '@angular/forms';
import { LgvUserService } from '../../../../core/core.module';
import { StartLoanModalComponent } from '../../../../shared/start-loan-modal/start-loan-modal.component';

@Component({
    selector: 'lgv-link-to-loan-dialog',
    templateUrl: './link-to-loan-dialog.component.html',
    styleUrls: ['./link-to-loan-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinkToLoanDialogComponent implements OnInit, OnDestroy {
    clientData: LgvModel.ClientInfo;
    linkedLoan: any;
    isLoading$ = new BehaviorSubject(true);
    loanApplications$ = new BehaviorSubject(null);
    linkedLoanAppForm: UntypedFormGroup;

    constructor(
        public dialogRef: MatDialogRef<LinkToLoanDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private loanAppService: LgvLoanApplicationService,
        private fb: UntypedFormBuilder,
        private dialog: MatDialog,
        private lgvUserSvc: LgvUserService
    ) {
        this.clientData = data?.clientData;
        this.linkedLoan = data?.linkedLoan;
    }

    ngOnDestroy(): void {
        this.isLoading$.complete();
    }

    ngOnInit(): void {
        this.linkedLoanAppForm = this.fb.group({
            loanApp: [this.linkedLoan, [Validators.required]]
        });

        this.fetchLoanApplications();
    }

    fetchLoanApplications() {
        this.loanAppService
            .fetchLoanApplications(this.clientData?.id)
            .pipe(
                first(),
                tap(la => {
                    this.loanApplications$.next(la?.value);
                    this.isLoading$.next(false);
                })
            )
            .subscribe();
    }

    openStartLoanApp() {
        this.lgvUserSvc.AgentDTO$.pipe(
            filter(f => f !== null),
            take(1)
        ).subscribe(agent => {
            const dialogRef = this.dialog.open(StartLoanModalComponent, {
                width: '700px',
                //height: '700px',
                panelClass: 'dialog-container',
                data: {
                    agentDTO: this.lgvUserSvc.IsAnyAdmin ? null : agent
                }
            });

            dialogRef
                .afterClosed()
                .pipe(first())
                .subscribe(x => {
                    if (x?.action === true) {
                        // Refresh page
                        this.fetchLoanApplications();
                    }
                });
        });
    }

    onSubmit() {
        this.dialogRef.close(this.linkedLoanAppForm.value);
    }
}
